<div class="row col-12" *ngIf="agrupacionesPropuestas.length > 0">
    <ng-container *ngFor="let agrupacion of agrupacionesPropuestas" class="col-8 mb-3">
        <p *ngIf="agrupacionesPropuestas.length > 1">{{ agrupacion.nombreColectivaPadre }}</p>
        <ng-container *ngFor="let pc of agrupacion.polizasColectivas">
            <div class="col-3">
                <p>{{ pc.polizaSalud?.modalidadColectiva }}</p>
                <ca-checkbox (valueChange)="changeImpresionColectiva($event, pc.polizaSalud?.codColectiva)">                               
                </ca-checkbox>
            </div>
            <div class="col-3" *ngIf="pc.polizaDescuento">
                <p>{{ pc.polizaDescuento?.modalidadColectiva }}</p>
                <ca-checkbox (valueChange)="changeImpresionColectiva($event, pc.polizaDescuento?.codColectiva)">                               
                </ca-checkbox>
            </div>
        </ng-container>
    </ng-container>
</div>
